import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaEgresos } from '../_egresos.js';

/**
 * El registro de una cortesia, dentro del grupo `_egresos`.
 *
 * Va aca y no en `_operacion` aunque el escenario empiece con el operario: `app.registrar_cortesia`
 * solo llama `app.assert_puede_operar()`, o sea que los CUATRO roles pueden registrar una, y
 * `_operacion` exige `jornada.abrirCerrar`, que la contadora no tiene. `_egresos` exige
 * `gastoCajaMenor.registrar`, la unica fila de la matriz de la feature 2 con si en las cuatro
 * columnas. Adjudicacion 177.
 *
 * Y una cortesia ES un egreso: vive en `public.egreso` con su propia `clase`. El grupo no se elige
 * por el tema, pero acá el tema y el publico coinciden.
 */
export const rutaCortesias = createRoute({
  getParentRoute: () => rutaEgresos,
  path: '/cortesias',
  component: lazyRouteComponent(() => import('./cortesias-pantalla.js'), 'RutaCortesias'),
});
